import { Category, User } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { UserCategoryPreferenceEntityConfig } from "./config";
import { UserCategoryPreferenceFilters } from "./filters";
import { UserCategoryPreferenceMethods } from "./methods";

@HyperEntity("user-category-preference", UserCategoryPreferenceEntityConfig)
export class UserCategoryPreference extends extender(
  UserCategoryPreferenceFilters,
  UserCategoryPreferenceMethods,
) {
  @Fields.string({ dbName: "user_id" })
  userId = "";

  @Fields.string({ dbName: "category_id" })
  categoryId = "";

  @Relations.toOne<UserCategoryPreference, Category>(
    () => Category,
    "categoryId",
  )
  category?: Category;

  @Relations.toOne<UserCategoryPreference, User>(() => User, "userId")
  user?: User;

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt? = new Date();

  @Fields.createdAt({ dbName: "created_at" })
  createdAt? = new Date();
}


